import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/BCN_Logo_Color-horiz.png")